import $ from 'jquery';
import 'slick-carousel';

const PropSlider = () => {

    let propCarousel = $('#propslider');

    propCarousel.slick({
        accessibility: false,
        adaptiveHeight: true,
        arrows: true,
        asNavFor: '#propnav',
        dots: false,
        draggable: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '.property-slider__arrow--prev',
        nextArrow: '.property-slider__arrow--next'
    });

    let sliderNav = $('#propnav');

    sliderNav.slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '#propslider',
        dots: false,
        focusOnSelect: true
    });
}


export default PropSlider;